<template>
  <v-btn
    icon
    small
    color="primary"
    title="Export to CSV file"
    class="action-btn"
    :disabled="disabled || isExporting"
    v-bind="$attrs"
    v-on="$listeners"
    @click="exportCSV"
  >
    <v-progress-circular v-if="isExporting" indeterminate size="16" width="2" />
    <v-icon v-else>mdi-download</v-icon>
  </v-btn>
</template>

<script>
import { constructCsvContent, forceFileDownload } from "../helpers/exportCSV";

export default {
  name: "ButtonExportCSV",
  props: {
    tableData: {
      validator: (prop) => prop === undefined || Array.isArray(prop),
      required: true,
    },
    headers: {
      type: Array,
      default: null,
    },
    filename: {
      type: String,
      default: "Storage Defender data",
    },
    triggerShowAll: {
      validator: (val) => typeof val === "function",
      default: null,
    },
    waitForData: {
      validator: (val) => typeof val === "function",
      default: null,
    },
    afterExport: {
      validator: (val) => typeof val === "function",
      default: null,
    },
    getTableData: {
      validator: (val) => typeof val === "function",
      default: null,
    },
  },
  data() {
    return {
      isExporting: false,
    };
  },
  computed: {
    disabled() {
      return !(this.tableData && this.tableData.length > 0);
    },
  },
  methods: {
    async exportCSV() {
      this.isExporting = true;

      try {
        if (this.triggerShowAll && this.waitForData) {
          await this.triggerShowAll();

          await this.waitForData();
        }

        const currentData = this.getTableData
          ? this.getTableData()
          : this.tableData;

        const csvContent = constructCsvContent(currentData, this.headers);
        forceFileDownload(csvContent, this.filename);

        if (this.afterExport) {
          await this.afterExport();
        }
      } catch (error) {
        console.error("ButtonExportCSV: Error preparing export:", error);
        if (this.afterExport) {
          await this.afterExport();
        }
      } finally {
        this.isExporting = false;
      }
    },
  },
};
</script>
